import { render } from "./RHAttendanceDashboard.vue?vue&type=template&id=b8ff0d42&scoped=true"
import script from "./RHAttendanceDashboard.vue?vue&type=script&lang=js"
export * from "./RHAttendanceDashboard.vue?vue&type=script&lang=js"

import "./RHAttendanceDashboard.vue?vue&type=style&index=0&id=b8ff0d42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8ff0d42"]])

export default __exports__